module.exports = __webpack_public_path__ + "img/child-avatar.8f0e45bc.svg";